module.exports = __webpack_public_path__ + "static/media/ic-language-gray-24-px.b712d030.svg";